import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { API } from '../constants';
import { ReactText } from 'react';
import {
    ACCOUNTING_AREA_ID_MARKER,
    processRequestForAccountingAreaWithReplacement,
} from './network/managedRequestForAccountingArea';
import { PbDispatch } from './index';
import { PbRequest } from './pbRequest';

export interface ApaleoPropertyDto {
    property_id: string;
    name: string;
    address1?: string;
    address2?: string;
    address3?: string;
    city: string;
    postal_code: string;
}

export interface ApaleoPropertyResponseDto {
    properties: ApaleoPropertyDto[];
    page: number;
    total_pages: number;
}

interface LocationApaleoPropertyStore {
    apaleoPropertyList?: ApaleoPropertyResponseDto;
}

const initialState: LocationApaleoPropertyStore = {
    apaleoPropertyList: undefined,
};

export const locationApaleoPropertySlice = createSlice({
    name: 'locationApaleoProperty',
    initialState,
    reducers: {
        setApaleoPropertyList(
            state: LocationApaleoPropertyStore,
            action: PayloadAction<ApaleoPropertyResponseDto>
        ) {
            state.apaleoPropertyList = action.payload;
        },
    },
});

export function LoadApaleoPropertyListForLocation(
    locationId: ReactText,
    page?: number
) {
    return async (dispatch: PbDispatch) => {
        try {
            const param = !!page ? `?page=${page}` : '?page=0';
            const response =
                await processRequestForAccountingAreaWithReplacement<ApaleoPropertyResponseDto>(
                    dispatch,
                    `${API}/${ACCOUNTING_AREA_ID_MARKER}/locations/${locationId}/pms/list-apaleo-properties${param}`,
                    { method: 'GET' },
                    PbRequest.GET_APALEO_PROPERTY_LIST
                );
            dispatch(
                locationApaleoPropertySlice.actions.setApaleoPropertyList(
                    response
                )
            );
        } catch {
            // handled
        }
    };
}

export function SetApaleoPropertyIdForLocation(
    locationId: ReactText,
    apaleoPropertyId: string,
    callback?: () => void
) {
    const request: RequestInit = {
        method: 'PUT',
        body: JSON.stringify({ pms_property_id: apaleoPropertyId }),
    };
    return async (dispatch: PbDispatch) => {
        try {
            await processRequestForAccountingAreaWithReplacement<void>(
                dispatch,
                `${API}/${ACCOUNTING_AREA_ID_MARKER}/locations/${locationId}/pms/set-apaleo-property`,
                request,
                PbRequest.PUT_APALEO_PROPERTY
            );
            callback?.();
        } catch {
            // already handled
        }
    };
}

export default locationApaleoPropertySlice.reducer;
